import {propOr} from 'ramda';

import {CATEGORIES, CATEGORY_LENSES_ID} from 'constants/category';
import {RouterInfoType} from 'reducers/routerInfo/routerInfoType';

/**
 * Returns the object for the "to" prop of the "react-router".
 * @param {string} url - Category url string
 * @returns {{pathname: string, state: RouterInfoType}} React router "to" object
 */
export function matchCategory(url: string): {pathname: string; state: RouterInfoType} {
    const {pathname} = new URL(url, window.SITE_URL || `https://${process.env.NGINX_DOMAIN}/`);
    // eslint-disable-next-line no-undefined
    const id = propOr<undefined, {}, number>(undefined, pathname.replace('/', ''), CATEGORIES);
    return {
        pathname: url,
        state: {
            page: 'category',
            params: {id, isContacts: id === CATEGORY_LENSES_ID},
        },
    };
}
